// features/onboarding/onboarding.service.ts
import { post, put } from '../../api/api.service';

export interface UserOnboardingPayload {
  personalId: string;
  firstName: string;
  email?: string;
  ssn: string;
  dateOfBirth: string;
  country: string;
  companyRegistrationNumber: string;
  city: string;
  vatNumber: string;
  address: string;
  ReferredByCode: string;
  ReferredByUserId: number | null;
  zipCode: string;
  profession: string;
  password: string;
  phoneNo: string;
  accountType: number;
}

export interface OnboardingApiResponse {
  statusCode: number;
  message: string;
  response: any;
}

export const submitUserOnboardingApi = async (payload: UserOnboardingPayload): Promise<OnboardingApiResponse> => {
  try {
    const response = await post<OnboardingApiResponse>('/useronboarding', payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateUserOnboarding = async (actionType: string , value: boolean): Promise<any> => {
    try {
        const response = await put<any>(
            `/useronboarding?actionType=${actionType}&flagValue=${value}`,
            {}
        );
        return response;
    } catch (error) {
        throw error;
    }
};
